import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";
import ObservationStatus from "@acto/taskpane/core/domain/ObservationStatus";

const UpdateObservationMutation = graphql(`
  mutation UpdateObservation($input: UpdateObservationInput!) {
    updateObservation(input: $input) {
      __typename
      id
      title {
        locale
        value
      }
      description {
        locale
        value
      }
      status
      processedReason
      client {
        __typename
        id
        name
      }
    }
  }
`);

export function useUpdateObservations() {
  const [result, _updateObservation] = useMutation(UpdateObservationMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateObservation = useCallback(
    async (id: string, status: ObservationStatus, reason?: string) => {
      try {
        const response = await _updateObservation({
          input: { id, status: status.toGraphql(), processedReason: reason },
        });

        if (response.error) {
          throw response.error;
        }

        if (!response.data || !response.data.updateObservation) {
          throw new Error("No data returned from updateObservation mutation");
        }

        return {
          id: response.data.updateObservation.id,
        };
      } catch (err: unknown) {
        console.log(err);
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [_updateObservation],
  );

  return { updateObservation, result, error };
}
